import type { ScriptLine } from "../../coldcompute";

// Caption lines are SCENE-LOCAL (fromSec resets to 0 inside each scene's <Sequence>).
// Sticky captions: each line stays until the next begins, so author ~5-6s apart.
// Every claim is grounded in EAKC-MVP src/lib/missions/orchestrator/ — see metadata.md.

export const HOOK: ScriptLine[] = [
  { scene: "hook", fromSec: 0.4, holdSec: 5, caption: "By default, my AI mission runs one step per tick — strictly in sequence." },
  { scene: "hook", fromSec: 5.6, holdSec: 5, caption: "So a plan's wall-clock is the SUM of every step, even the independent ones." },
];

export const PROBLEM: ScriptLine[] = [
  { scene: "problem", fromSec: 0.4, holdSec: 5.5, caption: "The serial orchestrator dispatches exactly ONE ready step, then waits for the next poll." },
  { scene: "problem", fromSec: 6, holdSec: 5.5, caption: "\"Research source A\" and \"Research source B\" don't depend on each other — yet B waits for A." },
  { scene: "problem", fromSec: 12, holdSec: 5.5, caption: "That's not a capability limit. It's a dispatch policy I chose to keep serial." },
];

export const INTUITION: ScriptLine[] = [
  { scene: "intuition", fromSec: 0.4, holdSec: 5.5, caption: "Intuition: a mission isn't a list. It's a DAG — steps with declared dependencies." },
  { scene: "intuition", fromSec: 6, holdSec: 5.5, caption: "Each step carries a blocked_by array. No edge between two steps means they can run together." },
];

export const DAG: ScriptLine[] = [
  { scene: "dag", fromSec: 0.4, holdSec: 5.5, caption: "The \"ready set\" = every step whose blocked_by deps are already complete, and not in flight." },
  { scene: "dag", fromSec: 6, holdSec: 5.5, caption: "With deps met, A and B are BOTH ready — so dispatch them in the same tick." },
  { scene: "dag", fromSec: 12, holdSec: 5.5, caption: "If nothing is ready but steps remain unfinished, readySteps reports stuck — a deadlock, not a hang." },
];

export const CODE: ScriptLine[] = [
  { scene: "code", fromSec: 0.5, holdSec: 5.5, caption: "readySteps scans the plan: skip completed, skip in-flight, collect the rest whose deps are met." },
  { scene: "code", fromSec: 6.5, holdSec: 6, caption: "Then it truncates the ready set to a cap — max(1, floor(maxParallel)) — so fan-out is bounded." },
  { scene: "code", fromSec: 13, holdSec: 6.5, caption: "The cap is the ONLY bound on parallel token burn — budget enforcement is off fleet-wide since May." },
];

export const DISPATCH: ScriptLine[] = [
  { scene: "dispatch", fromSec: 0.4, holdSec: 5.5, caption: "dispatchReadySet claims each step, then runs them with Promise.allSettled — concurrent, fail-isolated." },
  { scene: "dispatch", fromSec: 6, holdSec: 5.5, caption: "One step's rejection never loses the others' outcomes; each is reduced to a per-step result." },
  { scene: "dispatch", fromSec: 12, holdSec: 5.5, caption: "Then exactly ONE mission-row write per tick — sum the tokens, advance the index. Single writer." },
];

export const HONESTY: ScriptLine[] = [
  { scene: "honesty", fromSec: 0.4, holdSec: 5.5, caption: "Honesty: this is BUILT but ships behind a default-OFF flag. The serial path is what runs today." },
  { scene: "honesty", fromSec: 6, holdSec: 5.5, caption: "Parallel needs THREE gates: MISSIONS_PARALLEL_STEPS on, a cap above 1, and the mig-191 attestation." },
  { scene: "honesty", fromSec: 12, holdSec: 5.5, caption: "Miss any one and it falls back to the byte-identical serial path. Fail-closed for a cost knob." },
];

export const OUTRO: ScriptLine[] = [
  { scene: "outro", fromSec: 0.4, holdSec: 5.5, caption: "A list runs in order. A DAG runs by dependency — and the ready set can fan out." },
  { scene: "outro", fromSec: 6, holdSec: 4, caption: "Built, dark, and behind a flag. Next: how those agents coordinate — a shared blackboard, not a group chat." },
];

;
    var _remotion_globalVariableA;
    var _remotion_globalVariableB;
    // Legacy CSS implementations will `eval` browser code in a Node.js context
    // to extract CSS. For backwards compatibility, we need to check we're in a
    // browser context before continuing.
    if (typeof self !== 'undefined' &&
        // AMP / No-JS mode does not inject these helpers:
        '$RefreshHelpers$' in self) {
        const currentExports = __webpack_module__.exports;
        const prevExports = (_remotion_globalVariableB = (_remotion_globalVariableA = __webpack_module__.hot.data) === null || _remotion_globalVariableA === void 0 ? void 0 : _remotion_globalVariableA.prevExports) !== null && _remotion_globalVariableB !== void 0 ? _remotion_globalVariableB : null;
        // This cannot happen in MainTemplate because the exports mismatch between
        // templating and execution.
        self.$RefreshHelpers$.registerExportsForReactRefresh(currentExports, __webpack_module__.id);
        // A module can be accepted automatically based on its exports, e.g. when
        // it is a Refresh Boundary.
        if (self.$RefreshHelpers$.isReactRefreshBoundary(currentExports)) {
            // Save the previous exports on update so we can compare the boundary
            // signatures.
            __webpack_module__.hot.dispose((data) => {
                data.prevExports = currentExports;
            });
            // Unconditionally accept an update to this module, we'll check if it's
            // still a Refresh Boundary later.
            __webpack_module__.hot.accept();
            // This field is set when the previous version of this module was a
            // Refresh Boundary, letting us know we need to check for invalidation or
            // enqueue an update.
            if (prevExports !== null) {
                // A boundary can become ineligible if its exports are incompatible
                // with the previous exports.
                //
                // For example, if you add/remove/change exports, we'll want to
                // re-execute the importing modules, and force those components to
                // re-render. Similarly, if you convert a class component to a
                // function, we want to invalidate the boundary.
                if (self.$RefreshHelpers$.shouldInvalidateReactRefreshBoundary(prevExports, currentExports)) {
                    __webpack_module__.hot.invalidate();
                }
                else {
                    self.$RefreshHelpers$.scheduleUpdate();
                }
            }
        }
        else {
            // Since we just executed the code for the module, it's possible that the
            // new exports made it ineligible for being a boundary.
            // We only care about the case when we were _previously_ a boundary,
            // because we already accepted this update (accidental side effect).
            const isNoLongerABoundary = prevExports !== null;
            if (isNoLongerABoundary) {
                __webpack_module__.hot.invalidate();
            }
        }
    }
